import axios from "axios";

const getAll = async () => {
    try {
        const response = await axios.get("/api/admin/courses");
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const getOne = async (id) => {
    try {
        const response = await axios.get("/api/admin/course/" + id);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const addOne = async (data) => {
    try {
        const response = await axios.post("/api/admin/course", data);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const updateOne = async (id, data) => {
    try {
        const response = await axios.post("/api/admin/course/" + id, data);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const deleteOne = async (id) => {
    try {
        const response = await axios.delete("/api/admin/course/" + id);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export default {
    getAll,
    addOne,
    updateOne,
    deleteOne,
    getOne
}